import { createContext } from 'react';

import { LogSyncListItem } from '@totem/components/administration/logSync/types';

interface Context {
  loading: boolean;
  data: LogSyncListItem[];
  totalRecords: number;
  onRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  data: [],
  totalRecords: 0,
  onRefresh: () => {},
});
